import React from 'react'
import { IconContext } from 'react-icons'
import { FaRegLightbulb } from 'react-icons/fa'

const LightbulbIcon = () => {
  return (
    <IconContext.Provider value={{ color: "white", size: "5em" }}>
      <div>
        <FaRegLightbulb />
      </div>
    </IconContext.Provider>
  )
}

export default LightbulbIcon
